import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import {
    DashboardView,
    ItemsView,
    ShoppingCartView,
    BackOrderView,
    ProfileView,
    OrdersView,
    billingViwes,
    AboutUsView,
    ContactUsView,
    SelectAddressView,
    ValidateOrderView,
    CreteOrderView,
    BannerAdminIndex,
    Selector,
    reportsView,
    QuotaionViews,
    deliveryViews,
    savedViews,
    preliminaryViews,
    collectinViews,
    overdueViews,
    PromocionalesView,
    MyProfile,
    AutorizacionesView,
    MiddlewareView,
    SubirArchivo,
    CartsSavedView,
    OrderStatusView,
    DocumentsCreatedCMView,
    MyProfileSeller,
    AutoGestCartSavedView,
    RegistroPedidosView,
} from './views';
import PostBanner from './views/banners/postbanner';
import { connect } from 'react-redux';
import './App.css';
import 'react-notifications/lib/notifications.css';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import { DISPATCH_ID, config, ROLES } from './libs/utils/Const';
import { SearchItemsActions, Footer } from './components';
import CacheBuster from './CacheBuster';

class App extends Component {

    UNSAFE_componentWillMount() {
        const { setBusiness, setToken, setUser, setRememberUser, setRole, setLogOutReference } = this.props;

        //users
        let token = localStorage.getItem(config.general.localStorageNamed + 'Token');
        let role = localStorage.getItem(config.general.localStorageNamed + 'Role');
        let user = localStorage.getItem(config.general.localStorageNamed + 'CurrentUser');
        let rememberUser = localStorage.getItem(config.general.localStorageNamed + 'RememberUser');

        //console.log("app", 'token',token, 'business', config.general.business, 'user', user, 'role', role || ROLES.PUBLIC, 'rememberUser', rememberUser);

        user = JSON.parse(user) || {};

        setRole(role || ROLES.PUBLIC);
        setBusiness(config.general.business);
        setToken(token);
        setUser(user);
        setRememberUser(rememberUser);
        setLogOutReference(this.logOut);
    }

    logOut = () => {
        const { configReducer, setBusiness, setToken, setUser, setRememberUser, setRole, shoppingCartReducer: { getShoppingCart } } = this.props;
        //console.log('logout');
        localStorage.removeItem(config.general.localStorageNamed + 'Role');
        localStorage.removeItem(config.general.localStorageNamed + 'Token');
        localStorage.removeItem(config.general.localStorageNamed + 'CurrentUser');
        localStorage.removeItem(config.general.localStorageNamed + 'PartnerUser');
        localStorage.removeItem(config.general.localStorageNamed + 'RememberUser');
        localStorage.removeItem(config.general.localStorageNamed + 'vendor');
        localStorage.clear();
        configReducer.history.goHome();

        setRole(ROLES.PUBLIC);
        setBusiness(config.general.business);
        setToken(undefined);
        setUser({});
        setRememberUser(false);

        setTimeout(async () => {
            await getShoppingCart(true);
        }, 300);

    };

    componentDidMount() {
        const { addNotificationReference } = this.props;
        addNotificationReference(this.createNotification);
    }

    createNotification = action => {
        switch (action.type) {
            case 'info':
                NotificationManager.info(
                    action.message ? action.message : '',
                    action.title ? action.title : '',
                    action.timeOut ? action.timeOut : 3000,
                    action.callback ? action.callback : null
                );
                break;
            case 'success':
                NotificationManager.success(
                    action.message ? action.message : '',
                    action.title ? action.title : '',
                    action.timeOut ? action.timeOut : 3000,
                    action.callback ? action.callback : null
                );
                break;
            case 'warning':
                NotificationManager.warning(
                    action.message ? action.message : '',
                    action.title ? action.title : '',
                    action.timeOut ? action.timeOut : 3000,
                    action.callback ? action.callback : null
                );
                break;
            case 'error':
                NotificationManager.error(
                    action.message ? action.message : '',
                    action.title ? action.title : '',
                    action.timeOut ? action.timeOut : 3000,
                    action.callback ? action.callback : null
                );
                break;
            default:
                return;
        }
    };

    render() {
        const { spinner } = this.props.configReducer;
        const { addNotificationReference } = this.props;

        addNotificationReference(this.createNotification);
        return (
            <CacheBuster>
                {
                    ({loading, isLatestVersion, refreshCacheAndReload }) => {
                        if (loading) return null;
                        if (!loading && !isLatestVersion) {
                            refreshCacheAndReload();
                        }
                        return(
                        <div style={{ width: '100%' }}>
                            {spinner && (
                                <div className="loader" style={{ backgroundColor: config.general.loaderBackground }}>
                                    <div className="text-center">
                                        <div className={"spinner-border " + config.general.loaderColor} style={{ width: 45, height: 45 }} role="status">
                                            <span className="sr-only">{config.general.loaderImage}</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                            <NotificationContainer />
                            <SearchItemsActions />
                            <Switch>
                                <Route exact path="/" component={DashboardView} />
                                <Route exact path="/items" component={ItemsView} />
                                <Route exact path="/shoppingCart" component={ShoppingCartView} />
                                <Route exact path="/backOrder" component={BackOrderView} />
                                <Route exact path="/profile" component={ProfileView} />
                                <Route exact path="/orders" component={OrdersView} />
                                <Route exact path="/bill" component={billingViwes} />
                                <Route exact path="/aboutUs" component={AboutUsView} />
                                <Route exact path="/contactUs" component={ContactUsView} />
                                <Route exact path="/selectAddress" component={SelectAddressView} />
                                <Route exact path="/validateOrder" component={ValidateOrderView} />
                                <Route exact path="/createOrder" component={CreteOrderView} />
                                <Route exact path="/adminBanners" component={BannerAdminIndex} />
                                <Route exact path="/postbanner/:id/:slug" component={PostBanner} />
                                <Route exact path="/selector" component={Selector} />
                                <Route exact path="/reports" component={reportsView} />
                                <Route exact path="/quotations" component={QuotaionViews} />
                                <Route exact path="/delivery" component={deliveryViews} />
                                <Route exact path="/saveds" component={savedViews} />
                                <Route exact path="/prelimnarys" component={preliminaryViews} />
                                <Route exact path="/collections" component={collectinViews} />
                                <Route exact path="/overs" component={overdueViews} />
                                <Route exact path="/promocionales" component={PromocionalesView} />
                                <Route exact path="/myprofile" component={MyProfile} />
                                <Route exact path="/autorizaciones" component={AutorizacionesView} />
                                <Route exact path='/canalModerno' component={MiddlewareView}/>
                                <Route exact path="/subirArchivo" component={SubirArchivo} />
                                <Route exact path="/cartsSaved" component={CartsSavedView} />
                                <Route exact path="/orderStatus" component={OrderStatusView} />
                                <Route exact path="/DocumentsCreatedCM" component={DocumentsCreatedCMView} />
                                <Route exact path="/myprofileSeller" component={MyProfileSeller} />
                                <Route exact path="/autoGestCarts" component={AutoGestCartSavedView} /> 
                                <Route exact path="/registroPedidos" component={RegistroPedidosView} />                  
                                
                                <Route exact path="*" component={DashboardView} />


                                {/*shoppingCart
                                <Route exact path="/navbar/:family" component={DetailsNavBarMenu} />
                                {/*reports
                                <Route exact path="/reports" component={ReportsListView} />
                                {/*default
                                <Route exact path="*" component={HomeDashboardView} />
                                {/*groupdetails
                                <Route exact path="/groups" component={GroupsDetailsView} />

                            */}
                   
                            </Switch>
                            <Footer />
                        </div>
                        );
                    }
                }
            </CacheBuster>
        );
    }
}

const mapStateToProps = store => {
    return { 
        configReducer: store.ConfigReducer, 
        shoppingCartReducer: store.ShoppingCartReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        setRole: value => dispatch({ type: DISPATCH_ID.SESSION_SET_ROLE, value }),
        addNotificationReference: value => dispatch({ type: DISPATCH_ID.NOTIFICATION_SET_ALERT_REFERENCE, value }),
        setBusiness: value => dispatch({ type: DISPATCH_ID.SESSION_SET_BUSINESS_ID, value }),
        setToken: value => dispatch({ type: DISPATCH_ID.SESSION_SET_TOKEN, value }),
        setUser: value => dispatch({ type: DISPATCH_ID.SESSION_SET_USER, value }),
        setRememberUser: value => dispatch({ type: DISPATCH_ID.SESSION_SET_REMEMBER_USER, value }),
        setLogOutReference: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_LOG_OUT_REFERENCE, value }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
